export default "__VITE_ASSET__Dhg_xtfI__"